import { mfaChallengeGrant } from 'lib/helpers/mfaChallengeGrantStorage/mfaChallengeGrantStorage'

/**
 * Whether a challenge grant is held to re-mint an MFA sign-in challenge. The only such credential is the
 * password-free `mfaChallengeGrant` minted at sign-in for both password and OAuth users. It has no client
 * TTL — the backend owns its expiry and rejects a stale grant at redeem time — so this reflects only
 * whether a grant is held, not whether the backend still considers it valid.
 */
export const canReissueMfaChallenge = (): boolean => mfaChallengeGrant.get() !== null
